/** Inline text link on the auth pages ("Create account", "Forgot password?"). */
export const AUTH_LINK_CLASSES =
    'font-semibold text-content-secondary underline underline-offset-2 hover:text-content-primary';

/** Quieter recovery links ("Forgot password?"), padded to a 44px tap target. */
export const AUTH_SECONDARY_LINK_CLASSES =
    'inline-flex min-h-11 items-center text-label text-content-muted underline underline-offset-2 hover:text-content-primary';
